import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_TELECONSULT,
  DELETE_TELECONSULT,
  CONFIRM_TELECONSULT,
  COMPLETE_TELECONSULT,
  GET_TELECONSULT,
  GET_TELECONSULT_DETAILS,
  ADD_REMARKS_TELE_APPOINTMENTS,
  UPDATE_TELECONSULT,
} from "./actionTypes.js";

import {
  addTeleconsultFail,
  addTeleconsultSuccess,
  deleteTeleconsultFail,
  deleteTeleconsultSuccess, 
  confirmTeleconsultFail,
  confirmTeleconsultSuccess,
  getTeleconsultDetailsFail,
  getTeleconsultDetailsSuccess,
  getTeleconsultFail,
  getTeleconsultSuccess,
  updateTeleconsultFail,
  updateTeleconsultSuccess,
  completeTeleconsultFail,
  addRemakrsTeleAppointmentsSuccess,
  addRemakrsTeleAppointmentsFail,
} from "./actions.js";

import {
  addNewTeleconsult,
  teleconsultDetailsApi,
  teleconsultListingApi,
  delTeleconsult,
  confirmAppointment,
  updateTeleconsult,
  completeAppointment,
  completeTeleconsult,
  confirmTeleconsult,
  addRemarksTeleAppointment,
} from "./teleconsultApi.js";

function* fetchTeleconsult({ payload: length, sort, page, name, date, status, patientID }) {
  try {
    const response = yield call(teleconsultListingApi, length, sort, page, name, date, status, patientID)
    yield put(getTeleconsultSuccess(response))
  } catch (error) {
    yield put(getTeleconsultFail(error))
  }
}
function* fetchTeleconsultDetails({ payload: id }) {
  try {
    const response = yield call(teleconsultDetailsApi, id)
    yield put(getTeleconsultDetailsSuccess(response))
  } catch (error) {
    yield put(getTeleconsultDetailsFail(error))
  }
}

function* onAddNewTeleconsult({ payload: teleconsult }) {
  try {
    const response = yield call(addNewTeleconsult, teleconsult)
    yield put(addTeleconsultSuccess(response))
  } catch (error) {
    yield put(addTeleconsultFail(error))
  }
}

function* onUpdateTeleconsult({ payload: id, teleconsult }) {
  try {
    const response = yield call(updateTeleconsult, id, teleconsult)
    yield put(updateTeleconsultSuccess(response))
  } catch (error) {
    yield put(updateTeleconsultFail(error))
  }
}

function* onDelTeleconsult({ payload: id, msg }) {
  try {
    const response = yield call(delTeleconsult, id, msg)
    yield put(deleteTeleconsultSuccess(response))
  } catch (error) {
    yield put(deleteTeleconsultFail(error))
  }
}

function* onConfirmTeleconsult({ payload: id, teleconsult }) {
  try {
    const response = yield call(confirmTeleconsult, id, teleconsult)
    yield put(confirmTeleconsultSuccess(response))
  } catch (error) {
    yield put(confirmTeleconsultFail(error))
  }
}

function* onCompleteTeleconsult({ payload: id, teleconsult }) {
  try {
    const response = yield call(completeTeleconsult, id, teleconsult)
    yield put(completeTeleconsultFail(response))
  } catch (error) {
    yield put(completeTeleconsultFail(error))
  }
}

function* onAddRemarksAppointment({ payload: id, teleconsult }) {
  try {
    const response = yield call(addRemarksTeleAppointment, id, teleconsult)
    yield put(addRemakrsTeleAppointmentsSuccess(response))
  } catch (error) {
    yield put(addRemakrsTeleAppointmentsFail(error))
  }
}


function* TeleconsultSaga() {
  yield takeEvery(GET_TELECONSULT, fetchTeleconsult)
  yield takeEvery(GET_TELECONSULT_DETAILS, fetchTeleconsultDetails)
  yield takeEvery(ADD_NEW_TELECONSULT, onAddNewTeleconsult)
  yield takeEvery(UPDATE_TELECONSULT, onUpdateTeleconsult)
  yield takeEvery(DELETE_TELECONSULT, onDelTeleconsult)
  yield takeEvery(CONFIRM_TELECONSULT, onConfirmTeleconsult)
  yield takeEvery(COMPLETE_TELECONSULT, onCompleteTeleconsult)
  yield takeEvery(ADD_REMARKS_TELE_APPOINTMENTS, onAddRemarksAppointment)
}

export default TeleconsultSaga
